import React, { useEffect } from 'react';
import styles from './Tickets.module.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';

const LOGO_SRC = '/assets/Логотип ВВ/ВкусВилл зеленый/Лого-ВкусВилл-зеленый.png';

// Приём заявок от клиентов временно отключён (сбор персональных данных приостановлен).
// Форма ниже — статичная заглушка, она ничего не отправляет и не хранит данные.
export default function Tickets() {
  const navigate = useNavigate();

  // Запретить скролл на странице Tickets
  useEffect(() => {
    document.body.classList.add('tickets-no-scroll');
    return () => {
      document.body.classList.remove('tickets-no-scroll');
    };
  }, []);

  return (
    <div className={styles.ticketsPageWrapper} data-theme="light">
      {/* Анимированный градиентный фон */}
      <div className={styles.animatedBg}>
        <div className={styles.gradientOrb1}></div>
        <div className={styles.gradientOrb2}></div>
        <div className={styles.gradientOrb3}></div>
        <div className={styles.gradientOrb4}></div>
      </div>

      <div className={styles.ticketsCard}>
        <div className="text-center mb-3">
          <img src={LOGO_SRC} alt="ВкусВилл" className={styles.logo} />
        </div>
        <h2 className={styles.ticketsTitle}>Заявка для клиентов</h2>

        <div className={styles.suspendedWrapper}>
          <fieldset disabled className={`row g-3 ${styles.ticketsForm}`} aria-hidden="true">
            <div className="col-12 col-md-6">
              <label className={styles.formLabel}>ФИО *</label>
              <input className={styles.formInput} placeholder="Введите ФИО" tabIndex={-1} />
            </div>
            <div className="col-12 col-md-6">
              <label className={styles.formLabel}>Должность *</label>
              <input className={styles.formInput} placeholder="Ваша должность" tabIndex={-1} />
            </div>
            <div className="col-12 col-md-6">
              <label className={styles.formLabel}>Контакт (телефон/email)</label>
              <input className={styles.formInput} placeholder="+7... или email" tabIndex={-1} />
            </div>
            <div className="col-12 col-md-6">
              <label className={styles.formLabel}>Номер объекта (адрес) *</label>
              <input className={styles.formInput} placeholder="Введите адрес" tabIndex={-1} />
            </div>
            <div className="col-12">
              <label className={styles.formLabel}>Описание поломки *</label>
              <textarea className={styles.formTextarea} rows={3} placeholder="Опишите проблему" tabIndex={-1} />
            </div>
            <div className="col-12">
              <span className={styles.uploadBtn}>Загрузить фото</span>
              <span className={styles.fileHint}>До 5 файлов</span>
            </div>
            <div className="col-12 mt-2">
              <button className={styles.submitBtn} type="button" tabIndex={-1}>Отправить заявку</button>
            </div>
          </fieldset>

          <div className={styles.suspendedOverlay}>
            <div className={styles.suspendedIcon}>⏸</div>
            <b>Приём заявок временно приостановлен</b>
          </div>
        </div>

        <div className={styles.authSection}>
          <button className={styles.engineerBtnBig} onClick={() => navigate('/auth')}>
            Вход для инженеров
          </button>
        </div>
      </div>
    </div>
  );
}
